import demandsAPI from '.'

export async function getCompanyTeams(page = 1, limit = 10) {
	const { data } = await demandsAPI.get(
		`/teams/list?page=${page}&limit=${limit}`
	)

	return data
}

export async function createNewTeam(teamName) {
	const { data } = await demandsAPI.put(`/teams/create`, { teamName })

	return data
}
